module.exports = __webpack_public_path__ + "static/media/howToPC.6cb81617.png";